import { actionCreator } from 'utils';
import * as AccountancyTypes from '../types/accountancyTypes';


// E X P O R T S
export function loadAccountancyExports(data) {
    return {
        type: AccountancyTypes.LOAD_ACCOUNTANCY_EXPORTS,
        data,
    };
}

export function setAccountancyExportsPagination(key, pagination) {
    return {
        type: AccountancyTypes.SET_ACCOUNTANCY_EXPORTS_PAGINATION,
        key,
        pagination,
    };
}

export function exportAccountancyGroups(data) {
    return {
        type: AccountancyTypes.EXPORT_ACCOUNTANCY_GROUPS,
        data,
    };
}

export function exportAccountancyGroupsRes(data) {
    return {
        type: actionCreator(AccountancyTypes.EXPORT_ACCOUNTANCY_GROUPS, 'res'),
        data,
    };
}

export function exportAccountancyGroupsErr() {
    return {
        type: actionCreator(AccountancyTypes.EXPORT_ACCOUNTANCY_GROUPS, 'err'),
    };
}
// E X P O R T S

// S T A T I S T I C S
export function loadStatisticsExports(data) {
    return {
        type: AccountancyTypes.LOAD_STATISTICS_EXPORTS,
        data,
    };
}

export function setStatisticsExportsPagination(key, pagination) {
    return {
        type: AccountancyTypes.SET_STATISTICS_EXPORTS_PAGINATION,
        key,
        pagination,
    };
}

export function exportStatisticsGroups(data) {
    return {
        type: AccountancyTypes.EXPORT_STATISTICS_GROUPS,
        data,
    };
}

export function exportStatisticsGroupsRes(data) {
    return {
        type: actionCreator(AccountancyTypes.EXPORT_STATISTICS_GROUPS, 'res'),
        data,
    };
}

export function exportStatGroupsErr() {
    return {
        type: actionCreator(AccountancyTypes.EXPORT_STATISTICS_GROUPS, 'err'),
    };
}

export function loadStatisticsGroups() {
    return {
        type: AccountancyTypes.LOAD_STATISTICS_GROUPS,
    };
}

export function loadStatisticsGroupsRes(data) {
    return {
        type: actionCreator(AccountancyTypes.LOAD_STATISTICS_GROUPS, 'res'),
        data,
    };
}

export function loadStatisticsGroupsErr() {
    return {
        type: actionCreator(AccountancyTypes.LOAD_STATISTICS_GROUPS, 'err'),
    };
}
// S T A T I S T I C S

// A C C O U N T A N C Y   G R O U P S
export function loadAccountancyGroups() {
    return {
        type: AccountancyTypes.LOAD_ACCOUNTANCY_GROUPS,
    };
}

export function loadAccountancyGroupsRes(data) {
    return {
        type: actionCreator(AccountancyTypes.LOAD_ACCOUNTANCY_GROUPS, 'res'),
        data,
    };
}

export function loadAccountancyGroupsErr() {
    return {
        type: actionCreator(AccountancyTypes.LOAD_ACCOUNTANCY_GROUPS, 'err'),
    };
}
// A C C O U N T A N C Y   G R O U P S

// I N V O I C E
export function loadAccountancyInvoice() {
    return {
        type: AccountancyTypes.LOAD_ACCOUNTANCY_INVOICE,
    };
}

export function loadAccountancyInvoiceRes(data) {
    return {
        type: actionCreator(AccountancyTypes.LOAD_ACCOUNTANCY_INVOICE, 'res'),
        data,
    };
}

export function loadAccountancyInvoiceErr() {
    return {
        type: actionCreator(AccountancyTypes.LOAD_ACCOUNTANCY_INVOICE, 'err'),
    };
}

export function setAccountancyInvoicePagination(key, pagination) {
    return {
        type: AccountancyTypes.SET_ACCOUNTANCY_INVOICE_PAGINATION,
        key,
        pagination,
    };
}

export function loadAccountancyInvoiceOrders() {
    return {
        type: AccountancyTypes.LOAD_ACCOUNTANCY_INVOICE_ORDERS,
    };
}

export function loadAccountancyInvoiceOrdersErr() {
    return {
        type: actionCreator(AccountancyTypes.LOAD_ACCOUNTANCY_INVOICE_ORDERS, 'err'),
    };
}

export function loadAccountancyInvoiceOrdersRes(data) {
    return {
        type: actionCreator(AccountancyTypes.LOAD_ACCOUNTANCY_INVOICE_ORDERS, 'res'),
        data,
    };
}

export function setAccountancyInvoiceSort(key, type) {
    return {
        type: AccountancyTypes.SET_ACCOUNTANCY_INVOICE_SORT,
        sort: {
            key,
            type,
        },
    };
}

export function setAccountancyInvoiceFilters(key, value) {
    return {
        type: AccountancyTypes.SET_ACCOUNTANCY_INVOICE_FILTERS,
        key,
        value,
    };
}

export function resetAccountancyInvoiceFilters() {
    return {
        type: AccountancyTypes.RESET_ACCOUNTANCY_INVOICE_FILTERS,
    };
}
// I N V O I C E

// E X P O R T   I N V O I C E S
export function exportInvoices(invoiceType, invoiceAction, limit) {
    return {
        type: AccountancyTypes.EXPORT_INVOICES,
        invoiceType,
        invoiceAction,
        limit,
    };
}

export function exportInvoicesRes() {
    return {
        type: actionCreator(AccountancyTypes.EXPORT_INVOICES, 'res'),
    };
}

export function exportInvoicesErr() {
    return {
        type: actionCreator(AccountancyTypes.EXPORT_INVOICES, 'err'),
    };
}
// E X P O R T   I N V O I C E S
